import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import { cx } from '@emotion/css'
import { Card, Title } from '@offerzen/pinata-shame'

import { ApplicationStatus } from '@/CandidateExperience/constants/applicationStatus'
import { UserRole } from '@/CandidateExperience/helpers/constants'

import ApplyForm from './ApplyForm'
import AppliedContent from './AppliedContent'
import MatchingRequirements from './MatchingRequirements'
import styles from './styles'

const ApplicationCard = ({ className, theme, jobId, candidateSlug, candidateProfileId, application, companyName, handleApply }) => {
  return (
    <Card className={cx(styles.card, className)} theme={theme}>
      <Choose>
        <When condition={isEmpty(application)}>
          <Title className={styles.applyHeading}>Apply for this job</Title>
          <ApplyForm
            handleApply={handleApply}
            companyName={companyName}
            messageFieldDescription={
              <MatchingRequirements
                jobId={jobId}
                candidateProfileId={candidateProfileId}
                requirementListHeading={
                  <p className={styles.requirementListHeading}>Address requirements you don’t match in your message:</p>
                }
              />
            }
          />
        </When>

        <Otherwise>
          <AppliedContent
            applicationStatus={application.status}
            candidateSlug={candidateSlug}
            interviewRequestId={application.interviewRequest?.id}
            companyName={companyName}>
            <MatchingRequirements
              jobId={jobId}
              candidateProfileId={candidateProfileId}
              requirementListHeading={<h4>You don&apos;t match</h4>}
            />
          </AppliedContent>
        </Otherwise>
      </Choose>
    </Card>
  )
}

ApplicationCard.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.string,
  jobId: PropTypes.string.isRequired,
  candidateProfileId: PropTypes.string.isRequired,
  candidateSlug: PropTypes.string.isRequired,
  handleApply: PropTypes.func.isRequired,
  application: PropTypes.shape({
    status: PropTypes.oneOf(Object.values(ApplicationStatus)),
    interviewRequest: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  companyName: PropTypes.string.isRequired,
  loggedInUserRole: PropTypes.oneOf(Object.values(UserRole)),
}

export default ApplicationCard
